import { ElementRef, TemplateRef } from '@angular/core';
import { UserService } from '../../core/user/user.service';
import { User } from '../../core/user/user.model';
import { ActivatedRoute } from "@angular/router";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { RatingService } from '../rating/rating.service';
import { JhiLanguageService } from '../../ng-jhipster/language';
import { JhiEventManager } from '../../ng-jhipster/service';
import { SessionSettingService } from '../session-setting/session-setting.service';
import { SessionStorageService } from "ngx-webstorage";
import { TranslateService } from "@ngx-translate/core";
import { ContactMeModalComponent } from '../../shared/support/contact-me-modal.component';
import { AvailableCoachSlots } from '../session/schedule-session/available-coach-slots/available-coach-slots.model';
import { OrganizationResourceService } from '../../admin/organization-resource/organization-resource.service';
import { AccountService } from '../../core/auth/account.service';
import { TipService } from '../tip/tip.service';
import { CustomerCareModalComponent } from '../../shared/support/customer-care-modal.component';
import { TipFromCoachComponent } from '../../shared/tip-from-coach/tip-from-coach.component';
import { LookingForHelpTopicsService } from '../looking-for-help-topics/looking-for-help-topics.service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/user/user.service";
import * as i2 from "../rating/rating.service";
import * as i3 from "../session-setting/session-setting.service";
import * as i4 from "@angular/router";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
import * as i6 from "../../ng-jhipster/service";
import * as i7 from "@ngx-translate/core";
import * as i8 from "../../ng-jhipster/language";
import * as i9 from "ngx-webstorage";
import * as i10 from "../../admin/organization-resource/organization-resource.service";
import * as i11 from "../../core/auth/account.service";
import * as i12 from "../tip/tip.service";
import * as i13 from "../looking-for-help-topics/looking-for-help-topics.service";
import * as i14 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i15 from "@angular/common";
import * as i16 from "@fortawesome/angular-fontawesome";
import * as i17 from "@angular/cdk/scrolling";
import * as i18 from "../organization-resources/organization-resources.component";
import * as i19 from "../../shared/format-date-string.pipe";
const _c0 = function (a0) { return { count: a0 }; };
function WellbeingResult2Component_div_27_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 76);
    i0.ɵɵelementStart(1, "ngb-rating", 77);
    i0.ɵɵlistener("rateChange", function WellbeingResult2Component_div_27_div_3_Template_ngb_rating_rateChange_1_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.AVERAGE_RATING = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    const _r24 = i0.ɵɵreference(125);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("rate", ctx_r30.AVERAGE_RATING)("starTemplate", _r24)("readonly", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(4, _c0, ctx_r30.elementCount));
} }
function WellbeingResult2Component_div_27_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 71);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "formatDateString");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate("\"" + (ctx_r31.approvedList[ctx_r31.approvedRandomIndex2] == null ? null : ctx_r31.approvedList[ctx_r31.approvedRandomIndex2].message) + "\"");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(5, 2, ctx_r31.approvedList[ctx_r31.approvedRandomIndex1] == null ? null : ctx_r31.approvedList[ctx_r31.approvedRandomIndex1].creationDate, "D MMMM YYYY"));
} }
function WellbeingResult2Component_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "div", 66);
    i0.ɵɵlistener("click", function WellbeingResult2Component_div_27_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(); const _r26 = i0.ɵɵreference(127); return ctx_r34.open(_r26, ctx_r34.modalOptionsMd); });
    i0.ɵɵelement(2, "h3", 67);
    i0.ɵɵtemplate(3, WellbeingResult2Component_div_27_div_3_Template, 3, 6, "div", 68);
    i0.ɵɵelementStart(4, "div", 69);
    i0.ɵɵelementStart(5, "div", 70);
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 71);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "formatDateString");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, WellbeingResult2Component_div_27_div_11_Template, 6, 5, "div", 72);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 69);
    i0.ɵɵelementStart(13, "button", 73);
    i0.ɵɵlistener("click", function WellbeingResult2Component_div_27_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r35); const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.swipeReview("LEFT"); });
    i0.ɵɵelement(14, "fa-icon", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "button", 73);
    i0.ɵɵlistener("click", function WellbeingResult2Component_div_27_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r35); const ctx_r37 = i0.ɵɵnextContext(); return ctx_r37.swipeReview("RIGHT"); });
    i0.ɵɵelement(16, "fa-icon", 75);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.languageList != null);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate("\"" + (ctx_r0.approvedList[ctx_r0.approvedRandomIndex1] == null ? null : ctx_r0.approvedList[ctx_r0.approvedRandomIndex1].message) + "\"");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(10, 4, ctx_r0.approvedList[ctx_r0.approvedRandomIndex1] == null ? null : ctx_r0.approvedList[ctx_r0.approvedRandomIndex1].creationDate, "D MMMM YYYY"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.approvedList.length > 1);
} }
function WellbeingResult2Component__svg_use_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 80);
} }
function WellbeingResult2Component__svg_use_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 81);
} }
function WellbeingResult2Component_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 82);
    i0.ɵɵelementStart(2, "div", 83);
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelement(4, "img", 84);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 85);
    i0.ɵɵelement(6, "p", 86);
    i0.ɵɵelement(7, "p", 87);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function WellbeingResult2Component__svg_use_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 80);
} }
function WellbeingResult2Component__svg_use_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 81);
} }
const _c1 = function (a0, a1) { return { video: a0, text: a1 }; };
function WellbeingResult2Component_div_45_li_4_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 93);
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction2(1, _c1, ctx_r39.sessionDurationByType == null ? null : ctx_r39.sessionDurationByType.video, ctx_r39.sessionDurationByType == null ? null : ctx_r39.sessionDurationByType.text));
} }
function WellbeingResult2Component_div_45_li_4_p_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 94);
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction2(1, _c1, ctx_r40.sessionDurationByType == null ? null : ctx_r40.sessionDurationByType.video, ctx_r40.sessionDurationByType == null ? null : ctx_r40.sessionDurationByType.text));
} }
function WellbeingResult2Component_div_45_li_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, WellbeingResult2Component_div_45_li_4_p_1_Template, 1, 4, "p", 91);
    i0.ɵɵtemplate(2, WellbeingResult2Component_div_45_li_4_p_2_Template, 1, 4, "p", 92);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r38.sessionDurationByType.video !== ctx_r38.sessionDurationByType.text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r38.sessionDurationByType.video === ctx_r38.sessionDurationByType.text);
} }
function WellbeingResult2Component_div_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵelementStart(2, "li");
    i0.ɵɵelement(3, "p", 88);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, WellbeingResult2Component_div_45_li_4_Template, 3, 2, "li", 31);
    i0.ɵɵelementStart(5, "li");
    i0.ɵɵelement(6, "p", 89);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "li");
    i0.ɵɵelement(8, "p", 90);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r6.sessionDurationByType);
} }
function WellbeingResult2Component__svg_use_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 80);
} }
function WellbeingResult2Component__svg_use_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 81);
} }
function WellbeingResult2Component_div_54_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "p", 95);
    i0.ɵɵelement(2, "p", 96);
    i0.ɵɵelementStart(3, "ol", 97);
    i0.ɵɵelementStart(4, "li");
    i0.ɵɵelement(5, "span", 98);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "li");
    i0.ɵɵelement(7, "span", 99);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "li");
    i0.ɵɵelement(9, "span", 100);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "li");
    i0.ɵɵelement(11, "span", 101);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "h4", 102);
    i0.ɵɵelementStart(13, "button", 103);
    i0.ɵɵlistener("click", function WellbeingResult2Component_div_54_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r42); const ctx_r41 = i0.ɵɵnextContext(); return ctx_r41.displayCallMeModal(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", ctx_r9.getHowCoachText());
} }
function WellbeingResult2Component_div_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 104);
    i0.ɵɵelement(1, "h3", 105);
    i0.ɵɵelement(2, "span", 106);
    i0.ɵɵelement(3, "a", 107);
    i0.ɵɵelementEnd();
} }
function WellbeingResult2Component_div_57_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 108);
    i0.ɵɵelementStart(1, "div", 109);
    i0.ɵɵelement(2, "img", 110);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 111);
    i0.ɵɵelement(4, "h4", 112);
    i0.ɵɵelementStart(5, "div", 8);
    i0.ɵɵelementStart(6, "div", 49);
    i0.ɵɵelement(7, "span", 113);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 114);
    i0.ɵɵelementStart(9, "a", 115);
    i0.ɵɵlistener("click", function WellbeingResult2Component_div_57_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r44); const ctx_r43 = i0.ɵɵnextContext(); const _r28 = i0.ɵɵreference(129); return ctx_r43.open(_r28, ctx_r43.modalOptionsLg); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function WellbeingResult2Component_div_89_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 76);
    i0.ɵɵelementStart(1, "ngb-rating", 77);
    i0.ɵɵlistener("rateChange", function WellbeingResult2Component_div_89_div_3_Template_ngb_rating_rateChange_1_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(2); return ctx_r46.AVERAGE_RATING = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(2);
    const _r24 = i0.ɵɵreference(125);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("rate", ctx_r45.AVERAGE_RATING)("starTemplate", _r24)("readonly", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(4, _c0, ctx_r45.elementCount));
} }
function WellbeingResult2Component_div_89_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "div", 66);
    i0.ɵɵlistener("click", function WellbeingResult2Component_div_89_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(); const _r26 = i0.ɵɵreference(127); return ctx_r48.open(_r26, ctx_r48.modalOptionsMd); });
    i0.ɵɵelement(2, "h3", 116);
    i0.ɵɵtemplate(3, WellbeingResult2Component_div_89_div_3_Template, 3, 6, "div", 68);
    i0.ɵɵelementStart(4, "div", 69);
    i0.ɵɵelementStart(5, "div", 70);
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 71);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "formatDateString");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 69);
    i0.ɵɵelementStart(12, "button", 73);
    i0.ɵɵlistener("click", function WellbeingResult2Component_div_89_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r49); const ctx_r50 = i0.ɵɵnextContext(); return ctx_r50.swipeReview("LEFT"); });
    i0.ɵɵelement(13, "fa-icon", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "button", 73);
    i0.ɵɵlistener("click", function WellbeingResult2Component_div_89_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r49); const ctx_r51 = i0.ɵɵnextContext(); return ctx_r51.swipeReview("RIGHT"); });
    i0.ɵɵelement(15, "fa-icon", 75);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r12.languageList != null);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate("\"" + (ctx_r12.approvedList[ctx_r12.approvedRandomIndex1] == null ? null : ctx_r12.approvedList[ctx_r12.approvedRandomIndex1].message) + "\"");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(10, 3, ctx_r12.approvedList[ctx_r12.approvedRandomIndex1] == null ? null : ctx_r12.approvedList[ctx_r12.approvedRandomIndex1].creationDate, "D MMMM YYYY"));
} }
function WellbeingResult2Component__svg_use_96_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 80);
} }
function WellbeingResult2Component__svg_use_97_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 81);
} }
function WellbeingResult2Component_div_98_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "img", 84);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 117);
    i0.ɵɵelement(4, "p", 118);
    i0.ɵɵelement(5, "p", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function WellbeingResult2Component__svg_use_105_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 80);
} }
function WellbeingResult2Component__svg_use_106_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 81);
} }
function WellbeingResult2Component_div_107_li_4_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 125);
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction2(1, _c1, ctx_r53.sessionDurationByType == null ? null : ctx_r53.sessionDurationByType.video, ctx_r53.sessionDurationByType == null ? null : ctx_r53.sessionDurationByType.text));
} }
function WellbeingResult2Component_div_107_li_4_p_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 126);
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction2(1, _c1, ctx_r54.sessionDurationByType == null ? null : ctx_r54.sessionDurationByType.video, ctx_r54.sessionDurationByType == null ? null : ctx_r54.sessionDurationByType.text));
} }
function WellbeingResult2Component_div_107_li_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, WellbeingResult2Component_div_107_li_4_p_1_Template, 1, 4, "p", 123);
    i0.ɵɵtemplate(2, WellbeingResult2Component_div_107_li_4_p_2_Template, 1, 4, "p", 124);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r52.sessionDurationByType.video !== ctx_r52.sessionDurationByType.text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r52.sessionDurationByType.video === ctx_r52.sessionDurationByType.text);
} }
function WellbeingResult2Component_div_107_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵelementStart(2, "li");
    i0.ɵɵelement(3, "p", 120);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, WellbeingResult2Component_div_107_li_4_Template, 3, 2, "li", 31);
    i0.ɵɵelementStart(5, "li");
    i0.ɵɵelement(6, "p", 121);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "li");
    i0.ɵɵelement(8, "p", 122);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r18.sessionDurationByType);
} }
function WellbeingResult2Component__svg_use_112_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 80);
} }
function WellbeingResult2Component__svg_use_113_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 81);
} }
function WellbeingResult2Component_div_114_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "p", 9);
    i0.ɵɵelement(2, "p", 127);
    i0.ɵɵelementStart(3, "ol", 97);
    i0.ɵɵelementStart(4, "li");
    i0.ɵɵelement(5, "span", 128);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "li");
    i0.ɵɵelement(7, "span", 129);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "li");
    i0.ɵɵelement(9, "span", 130);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "li");
    i0.ɵɵelement(11, "span", 131);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "h4", 102);
    i0.ɵɵelementStart(13, "button", 103);
    i0.ɵɵlistener("click", function WellbeingResult2Component_div_114_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(); return ctx_r55.displayCallMeModal(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", ctx_r21.getHowCoachText());
} }
function WellbeingResult2Component_div_115_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 104);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelement(2, "h3", 132);
    i0.ɵɵelement(3, "p", 133);
    i0.ɵɵelement(4, "a", 134);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function WellbeingResult2Component_div_116_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 135);
    i0.ɵɵelementStart(1, "div", 109);
    i0.ɵɵelement(2, "img", 110);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 111);
    i0.ɵɵelement(4, "h3", 136);
    i0.ɵɵelementStart(5, "div", 8);
    i0.ɵɵelementStart(6, "div", 49);
    i0.ɵɵelement(7, "span", 113);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 114);
    i0.ɵɵelementStart(9, "a", 115);
    i0.ɵɵlistener("click", function WellbeingResult2Component_div_116_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(); const _r28 = i0.ɵɵreference(129); return ctx_r57.open(_r28, ctx_r57.modalOptionsLg); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c2 = function () { return ["fas", "star"]; };
const _c3 = function () { return ["far", "star"]; };
function WellbeingResult2Component_ng_template_124_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 137);
    i0.ɵɵelementStart(1, "span", 138);
    i0.ɵɵelementStart(2, "em", 139);
    i0.ɵɵelement(3, "fa-icon", 140);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "em", 141);
    i0.ɵɵelement(5, "fa-icon", 140);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const fill_r59 = ctx.fill;
    i0.ɵɵclassProp("full", fill_r59 === 100);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", fill_r59, "%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(6, _c2));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(7, _c3));
} }
const _c4 = function (a0) { return { width: a0 }; };
function WellbeingResult2Component_ng_template_126_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 152);
    i0.ɵɵelementStart(1, "div", 153);
    i0.ɵɵelementStart(2, "div", 154);
    i0.ɵɵlistener("click", function WellbeingResult2Component_ng_template_126_div_8_Template_div_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r65); const s_r63 = restoredCtx.$implicit; const ctx_r64 = i0.ɵɵnextContext(2); return ctx_r64.filter(s_r63); });
    i0.ɵɵelement(3, "span", 155);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 156);
    i0.ɵɵelement(5, "div", 157);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 158);
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r63 = ctx.$implicit;
    const ctx_r61 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("jhiTranslate", "inukaNgApp.wellBeingResult2.review." + s_r63 + "stars");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(3, _c4, ctx_r61.calculateProgressBarWidth(s_r63)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r61.percentage + "%");
} }
function WellbeingResult2Component_ng_template_126_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r68 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "hr");
    i0.ɵɵelementStart(2, "div", 159);
    i0.ɵɵelementStart(3, "div", 160);
    i0.ɵɵelementStart(4, "ngb-rating", 77);
    i0.ɵɵlistener("rateChange", function WellbeingResult2Component_ng_template_126_div_11_Template_ngb_rating_rateChange_4_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r68); const r_r66 = restoredCtx.$implicit; return r_r66.rating = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "h5", 161);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 162);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 163);
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵelementStart(12, "span");
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r66 = ctx.$implicit;
    i0.ɵɵnextContext(2);
    const _r24 = i0.ɵɵreference(125);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("rate", r_r66.rating)("starTemplate", _r24)("readonly", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(r_r66.coachLogin);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(9, 6, r_r66.creationDate, "dd MM yyyy"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(r_r66 == null ? null : r_r66.message);
} }
function WellbeingResult2Component_ng_template_126_Template(rf, ctx) { if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelementStart(1, "div", 142);
    i0.ɵɵelementStart(2, "div", 143);
    i0.ɵɵelementStart(3, "fa-icon", 144);
    i0.ɵɵlistener("click", function WellbeingResult2Component_ng_template_126_Template_fa_icon_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r70); const modal_r60 = restoredCtx.$implicit; const ctx_r69 = i0.ɵɵnextContext(); modal_r60.close("close"); return ctx_r69.filter(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 145);
    i0.ɵɵelementStart(5, "div", 146);
    i0.ɵɵelementStart(6, "ngb-rating", 77);
    i0.ɵɵlistener("rateChange", function WellbeingResult2Component_ng_template_126_Template_ngb_rating_rateChange_6_listener($event) { i0.ɵɵrestoreView(_r70); const ctx_r71 = i0.ɵɵnextContext(); return ctx_r71.averageRating = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 147);
    i0.ɵɵlistener("click", function WellbeingResult2Component_ng_template_126_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r70); const ctx_r72 = i0.ɵɵnextContext(); return ctx_r72.filter(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, WellbeingResult2Component_ng_template_126_div_8_Template, 9, 5, "div", 148);
    i0.ɵɵelementStart(9, "div", 149);
    i0.ɵɵelementStart(10, "cdk-virtual-scroll-viewport", 150);
    i0.ɵɵtemplate(11, WellbeingResult2Component_ng_template_126_div_11_Template, 14, 9, "div", 151);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext();
    const _r24 = i0.ɵɵreference(125);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("rate", ctx_r27.averageRating)("starTemplate", _r24)("readonly", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(8, _c0, ctx_r27.elementCount));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r27.stars);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("itemSize", 80);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("cdkVirtualForOf", ctx_r27.ratingList)("cdkVirtualForTemplateCacheSize", 0);
} }
function WellbeingResult2Component_ng_template_128_Template(rf, ctx) { if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelementStart(1, "div", 164);
    i0.ɵɵelementStart(2, "div", 143);
    i0.ɵɵelementStart(3, "fa-icon", 144);
    i0.ɵɵlistener("click", function WellbeingResult2Component_ng_template_128_Template_fa_icon_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r75); const modal_r73 = restoredCtx.$implicit; const ctx_r74 = i0.ɵɵnextContext(); modal_r73.close("close"); return ctx_r74.filter(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 145);
    i0.ɵɵelement(5, "organization-resources", 165);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("userId", ctx_r29.currentUser.id)("isPopup", true);
} }
const _c5 = function (a0) { return { user: a0 }; };
const _c6 = function (a0) { return { "margin-bottom": a0 }; };
const maxCoachesForTipsIndex = 2;
export class WellbeingResult2Component {
    constructor(userService, ratingService, sessionSettingService, activatedRoute, modalService, elementRef, eventManager, translateService, languageService, sessionStorage, organizationResourceService, accountService, tipService, lookingForHelpTopicsService) {
        this.userService = userService;
        this.ratingService = ratingService;
        this.sessionSettingService = sessionSettingService;
        this.activatedRoute = activatedRoute;
        this.modalService = modalService;
        this.elementRef = elementRef;
        this.eventManager = eventManager;
        this.translateService = translateService;
        this.languageService = languageService;
        this.sessionStorage = sessionStorage;
        this.organizationResourceService = organizationResourceService;
        this.accountService = accountService;
        this.tipService = tipService;
        this.lookingForHelpTopicsService = lookingForHelpTopicsService;
        this.allRatingList = [];
        this.approvedList = [];
        this.ratingList = [];
        this.sumOfRatings = 0;
        this.modalOptionsMd = { windowClass: 'modal-window', size: 'md' };
        this.modalOptionsLg = { windowClass: 'modal-window', size: 'lg' };
        this.stars = [5, 4, 3, 2, 1];
        this.coaches = [];
        this.coachLogins = [];
        this.coachIndex = 0;
        this.selectedLanguage = this.languageService.getCurrentLanguage();
        this.langKey = this.languageService.getCurrentLanguage() ? this.languageService.getCurrentLanguage() : "en";
        this.showCoaches = false;
        this.showHowSession = false;
        this.showHowCoach = false;
        this.modalOptions = { windowClass: 'modal-window', size: 'sm' };
        this.startNowLink = "";
    }
    ngOnInit() {
        this.getRatings();
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#F7F4EB';
        this.userServiceSubscription = this.userService.current().subscribe(user => {
            this.currentUser = user;
            if (this.currentUser != null)
                this.getShowResourcesLink();
            this.sessionDurationByType = this.sessionSettingService.loadSessionDurationByType(user);
            this.lookingForHelpTopicsService.getUserLastLookingForHelpTopics().subscribe((response) => {
                const topics = response.body.topics;
                this.showHelpList = topics === null || topics === undefined;
                this.startNowLink = this.showHelpList ? '/match-with-a-coach/1' : '/match-with-a-coach/2';
            }, error => {
                console.log(error);
                if (error.status === 404) {
                    this.startNowLink = '/match-with-a-coach/1';
                }
            });
        });
        this.activatedRoute.params.subscribe((params) => {
            this.totalScore = params["totalScore"];
            this.isTough = this.totalScore <= 3;
            this.isAtRisk = this.totalScore >= 4 && this.totalScore <= 13;
            this.isResilient = this.totalScore >= 14;
            this.sessionStorage.store("totalScore", this.totalScore);
        });
        this.translateServiceSubscription = this.translateService.onLangChange.subscribe(() => {
            this.selectedLanguage = this.languageService.getCurrentLanguage();
            this.getRatings();
        });
        this.populateCoachList();
        this.eventManager.subscribe('langKeyChanged', () => {
            if (this.currentUser != null)
                this.populateCoachList();
        });
        this.eventManager.subscribe('langKeyChanged', () => {
            if (this.currentUser != null)
                this.getShowResourcesLink();
        });
        this.userService.getEligibleCoaches().subscribe(coachesForTips => {
            this.coachesForTips = coachesForTips.coaches.sort((a, b) => a.coachDisplayOrder < b.coachDisplayOrder ? -1 : 1).slice(0, maxCoachesForTipsIndex);
            this.selectedCoachForTip = this.coachesForTips[Math.floor(Math.random() * this.coachesForTips.length)];
            console.log(this.selectedCoachForTip);
            this.tipService.selectTip().subscribe(tip => {
                this.selectedTip = tip.body;
                console.log(this.selectedTip);
            });
        });
    }
    getShowResourcesLink() {
        this.langKey = this.languageService.getCurrentLanguage() ? this.languageService.getCurrentLanguage() : "en";
        this.organizationResourceService.getOrganizationResourcesByUserIdAndLangkey(this.currentUser.id, this.langKey).subscribe(res => {
            this.organizationResources = res.body || [];
            let organizationResourcesLength = this.organizationResources.length;
            console.log("Organization resources length: " + organizationResourcesLength);
            this.showResourcesLink = organizationResourcesLength > 0 && this.accountService.hasAnyAuthority(['ROLE_USER']);
        });
    }
    getRatings() {
        this.ratingService.findAllRatingsForUser().subscribe((res) => {
            this.allRatingList = res.body;
            this.ratingList = JSON.parse(JSON.stringify(this.allRatingList));
            console.log(this.selectedLanguage);
            this.languageList = res.body.filter(r => r.lang === this.selectedLanguage);
            if (this.languageList.length === 0)
                this.languageList = res.body.filter(r => r.lang === 'en');
            this.approvedList = this.languageList.filter(r => r.approved === true);
            this.approvedRandomIndex1 = Math.floor(Math.random() * this.approvedList.length);
            this.approvedRandomIndex2 = Math.floor(Math.random() * this.approvedList.length);
            while (this.approvedRandomIndex2 === this.approvedRandomIndex1 && this.approvedList.length > 1) { // This is to ensure the review cards in the desktop view are not the same. If there are the same then the code will try to find a new random index.
                this.approvedRandomIndex1 = Math.floor(Math.random() * this.approvedList.length);
            }
            this.allRatingList.forEach(r => { this.sumOfRatings = this.sumOfRatings + r.rating; });
            this.AVERAGE_RATING = this.sumOfRatings / this.allRatingList.length;
            this.calculateListParameters(this.allRatingList);
        });
    }
    populateCoachList() {
        this.coaches = [];
        this.coachLogins = [];
        this.userService.getAllAvailableCoachReasonings().subscribe((res) => {
            const availableCoachSlots = new AvailableCoachSlots(res);
            for (const day of availableCoachSlots.days) {
                for (const coachesSlot of day.coachesSlots) {
                    if (!this.coachLogins.includes(coachesSlot.coach.login)) {
                        this.coachLogins.push(coachesSlot.coach.login);
                        this.coaches.push(coachesSlot);
                    }
                }
            }
            this.maxCoachIndex = this.coaches.length - 1;
        });
    }
    calculateListParameters(l) {
        this.sumOfRatings = 0;
        this.elementCount = 0;
        this.randomIndex = 0;
        this.averageRating = 0;
        if (l.length > 0) {
            this.elementCount = l.length;
            this.randomIndex = Math.floor(Math.random() * this.elementCount);
            l.forEach(r => { this.sumOfRatings = this.sumOfRatings + r.rating; });
            this.averageRating = this.sumOfRatings / this.elementCount;
        }
    }
    getSummaryText(index) {
        if (this.isTough) {
            return 'inukaNgApp.wellBeingResult2.summary.yourScoreTough' + index;
        }
        else if (this.isAtRisk) {
            return 'inukaNgApp.wellBeingResult2.summary.yourScoreAtRisk' + index;
        }
        else if (this.isResilient) {
            return 'inukaNgApp.wellBeingResult2.summary.yourScoreResilient' + index;
        }
        else {
            return '';
        }
    }
    getHowSessionText() {
        if (this.isTough) {
            return 'inukaNgApp.wellBeingResult2.howSession.isTough';
        }
        else if (this.isAtRisk) {
            return 'inukaNgApp.wellBeingResult2.howSession.isAtRisk';
        }
        else if (this.isResilient) {
            return 'inukaNgApp.wellBeingResult2.howSession.isResilient';
        }
        else {
            return '';
        }
    }
    getHowCoachText() {
        if (this.isTough || this.isAtRisk) {
            return 'inukaNgApp.wellBeingResult2.howCoach.isNotResilient';
        }
        else if (this.isResilient) {
            return 'inukaNgApp.wellBeingResult2.howCoach.isResilient';
        }
        else {
            return '';
        }
    }
    open(modal, options) {
        this.modalService.open(modal, options).result.then(() => { }, (reason) => {
            if (reason === ModalDismissReasons.ESC || reason === ModalDismissReasons.BACKDROP_CLICK) {
                this.filter();
            }
        });
    }
    calculateProgressBarWidth(starCount) {
        if (this.ratingList.length === 0)
            return '';
        this.percentage = Math.floor(100 * (this.ratingList.filter(e => e.rating === starCount).length) / this.ratingList.length);
        return this.percentage + '%';
    }
    swipeLeft() {
        if (this.coachIndex === 0) {
            this.coachIndex = this.maxCoachIndex;
        }
        else {
            this.coachIndex--;
        }
    }
    swipeRight() {
        if (this.coachIndex === this.maxCoachIndex) {
            this.coachIndex = 0;
        }
        else {
            this.coachIndex++;
        }
    }
    filter(s) {
        if (s)
            this.ratingList = this.allRatingList.filter(r => r.rating === s);
        else
            this.ratingList = this.allRatingList;
        this.calculateListParameters(this.ratingList);
    }
    displayCallMeModal() {
        const modalRef = this.modalService.open(ContactMeModalComponent, this.modalOptionsMd);
        modalRef.componentInstance.contactUserModalRef = modalRef;
    }
    swipeReview(direction) {
        if (direction === 'LEFT') {
            this.approvedRandomIndex2 = JSON.parse(JSON.stringify(this.approvedRandomIndex1));
            this.approvedRandomIndex1 = Math.floor(Math.random() * this.approvedList.length);
            while (this.approvedRandomIndex1 === this.approvedRandomIndex2 && this.approvedList.length > 1) {
                this.approvedRandomIndex1 = Math.floor(Math.random() * this.approvedList.length);
            }
        }
        else if (direction === 'RIGHT') {
            this.approvedRandomIndex1 = JSON.parse(JSON.stringify(this.approvedRandomIndex2));
            this.approvedRandomIndex2 = Math.floor(Math.random() * this.approvedList.length);
            while (this.approvedRandomIndex2 === this.approvedRandomIndex1 && this.approvedList.length > 1) {
                this.approvedRandomIndex2 = Math.floor(Math.random() * this.approvedList.length);
            }
        }
        else {
            console.log('Swipe direction is not recognized: ' + direction);
        }
    }
    openFaqPage() {
        const faqPageAddress = this.selectedLanguage === 'nl' ? 'https://inukacoaching.com/nl/faq/' : 'https://inukacoaching.com/faq/';
        window.open(faqPageAddress, '_blank');
    }
    openMessageModal() {
        this.modalService.open(CustomerCareModalComponent, this.modalOptions);
    }
    openTip(tip, coach) {
        tip.coach = new User();
        tip.coach.id = coach.id;
        tip.coach.login = coach.login;
        console.log(tip);
        const modalRef = this.modalService.open(TipFromCoachComponent, { size: 'md' });
        modalRef.componentInstance.tip = tip;
    }
    ngOnDestroy() {
        var _a, _b;
        (_a = this.userServiceSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.translateServiceSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    }
}
WellbeingResult2Component.ɵfac = function WellbeingResult2Component_Factory(t) { return new (t || WellbeingResult2Component)(i0.ɵɵdirectiveInject(i1.UserService), i0.ɵɵdirectiveInject(i2.RatingService), i0.ɵɵdirectiveInject(i3.SessionSettingService), i0.ɵɵdirectiveInject(i4.ActivatedRoute), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i6.JhiEventManager), i0.ɵɵdirectiveInject(i7.TranslateService), i0.ɵɵdirectiveInject(i8.JhiLanguageService), i0.ɵɵdirectiveInject(i9.SessionStorageService), i0.ɵɵdirectiveInject(i10.OrganizationResourceService), i0.ɵɵdirectiveInject(i11.AccountService), i0.ɵɵdirectiveInject(i12.TipService), i0.ɵɵdirectiveInject(i13.LookingForHelpTopicsService)); };
WellbeingResult2Component.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WellbeingResult2Component, selectors: [["wellbeing-result2"]], viewQuery: function WellbeingResult2Component_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(CdkVirtualScrollViewport, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewport = _t.first);
    } }, decls: 130, vars: 46, consts: [[1, "olha-theme"], [1, "d-none", "d-lg-block", "d-xl-block"], [1, "container", "summary-container", "bg-white", "row"], [1, "col-9"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.summary.header", 1, "thank-you-header", 3, "translateValues"], [1, "mb-2"], [1, "mb-3"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.summary.nextStep", 1, "text-18"], [1, "mt-2", "mb-2"], [3, "jhiTranslate"], [1, "container", "p-0", "d-flex", "justify-content-start"], ["routerLink", "/wellbeing-result", "jhiTranslate", "inukaNgApp.wellBeingResult2.summary.toResults", 1, "btn", "btn-link"], [1, "col-3"], ["src", "../../../../content/images/stars.svg", "alt", "stars.svg"], [1, "container", "match-with-coach-container", "row"], [1, "image-div"], ["src", "../../../../content/images/wellbeing/blob-hero.png", "alt", "blob-hero"], [1, "m-2"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.summary.nextSteps", 2, "font-weight", "bold", "color", "#44A38B"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.summary.matchCoach", 1, "match-with-your-inuka-coach-header", "mb-3"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.summary.4Steps", 1, "match-with-coach-text"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.summary.startNow", 1, "btn", "btn-primary", "mt-2", 3, "routerLink"], [1, "row", "justify-content-center", "bottom-div"], [1, "col-8", 2, "padding", "0 10px 0 0!important", "height", "100%!important"], ["class", "container review-container bg-white", 4, "ngIf"], [1, "container", "how-coach-container", "bg-white"], [1, "d-flex", "justify-content-between", 2, "cursor", "pointer", 3, "click"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.header", 1, "h3"], [1, "angle-icon"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-up-0A4A3A", 4, "ngIf"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-down-0A4A3A", 4, "ngIf"], [4, "ngIf"], [1, "container", "how-session-container", "bg-white"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.header", 1, "h3"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.howHelp", 1, "h3"], [1, "col-4", 2, "padding", "0 0 0 10px!important", "height", "100%!important"], ["class", "container meet-coaches-container bg-white", 4, "ngIf"], ["class", "container bg-white", "style", "padding: 20px 20px!important; margin-left: 0", 4, "ngIf"], [1, "container", "bg-white", 2, "padding", "30px 20px!important", "margin-left", "0", "margin-top", "20px"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.moreQuestions", 2, "margin-bottom", "15px!important"], [1, "container", "resources-for-help-container", "bg-white", 2, "margin-bottom", "13px!important"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.faq", 1, "btn-link", 3, "click"], [1, "container", "resources-for-help-container", "bg-white"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.clientSupport", 1, "btn-link", 3, "click"], [1, "d-lg-none", 2, "margin-bottom", "40px!important"], [1, "col-4", 2, "padding-right", "0!important"], ["src", "../../../../content/images/blob-with-flag.svg", "alt", "blob-with-flag.svg", 1, "image"], [1, "col-8", "mt-4"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.summary.header", 1, "thank-you-header", "mt-2", 3, "translateValues"], [2, "width", "auto!important"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.summary.nextStep", 1, "text-14"], [1, "container", "p-0", "d-flex", "justify-content-center"], ["routerLink", "/wellbeing-result", "jhiTranslate", "inukaNgApp.wellBeingResult2.summary.toResults", 1, "btn", "btn-link", "m-2", 2, "font-size", "12px!important"], [1, "container", "summary-container", "row", 2, "margin-top", "20px!important", "background", "#F7EED2"], [1, "d-flex", "justify-content-between", "align-items-center", 2, "flex-direction", "column"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.summary.matchCoach", 1, "match-with-your-inuka-coach-header"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.header", 1, "h3", 2, "font-size", "18px", "font-style", "normal", "font-weight", "600", "line-height", "130%"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.header", 1, "h3", 2, "font-size", "18px", "font-style", "normal", "font-weight", "600", "line-height", "130%"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.howHelp", 1, "h3", 2, "font-size", "18px", "font-style", "normal", "font-weight", "600", "line-height", "130%"], ["class", "container more-question-container bg-white", 4, "ngIf"], [1, "container", "more-question-container", "bg-white", 2, "padding-top", "30px!important"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.moreQuestions", 1, "match-with-your-inuka-coach-header", 2, "margin-bottom", "15px!important"], ["t", ""], ["reviewListModal", ""], ["organizationResourcesModal", ""], [1, "container", "review-container", "bg-white"], [3, "click"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.review.header"], ["class", "d-flex justify-content-start align-items-center review-count-div", 4, "ngIf"], [1, "d-flex", "justify-content-center", "align-items-center", "mt-3"], [1, "rating-container", "mr-3", "d-flex", "justify-content-between", 2, "flex-direction", "column"], [1, "writer"], ["class", "rating-container ml-3 justify-content-between", "style", "flex-direction: column", 4, "ngIf"], [1, "scroll", 3, "click"], ["icon", "arrow-left", 1, "review-scroll-arrow"], ["icon", "arrow-right", 1, "review-scroll-arrow"], [1, "d-flex", "justify-content-start", "align-items-center", "review-count-div"], ["max", "5", 3, "rate", "starTemplate", "readonly", "rateChange"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.review.count", 1, "review-count", 3, "translateValues"], [1, "rating-container", "ml-3", "justify-content-between", 2, "flex-direction", "column"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-up-0A4A3A"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-down-0A4A3A"], [1, "row"], [1, "col-3", "pt-4"], ["src", "../../../../content/images/cce.png", "alt", "cce.png"], [1, "col-9", "pt-4"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.experiencedCoaches", 1, "text-16"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.allCoaches", 1, "text-16"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.firstSession", 1, "text-16"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.sessionType", 1, "text-16"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.asMany", 1, "text-16"], ["class", "text-16", "jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.sessionDuration", 3, "translateValues", 4, "ngIf"], ["class", "text-16", "jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.sessionSameDuration", 3, "translateValues", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.sessionDuration", 1, "text-16", 3, "translateValues"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.sessionSameDuration", 1, "text-16", 3, "translateValues"], [1, "text-16", 3, "jhiTranslate"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.session", 1, "text-16"], [2, "margin-top", "20px!important"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.1", 1, "text-16"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.2", 1, "text-16"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.3", 1, "text-16"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.4", 1, "text-16"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.easy", 2, "margin-top", "20px!important"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.contactMe", 1, "btn", "btn-secondary", "mt-2", 3, "click"], [1, "container", "meet-coaches-container", "bg-white"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.summary.findYourself", 1, "match-with-your-inuka-coach-header"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.summary.explore", 1, "match-with-coach-text"], ["routerLink", "/session/schedule-session", "jhiTranslate", "inukaNgApp.wellbeingStart.viewAllCoaches", 1, "btn", "btn-link", "mt-3"], [1, "container", "bg-white", 2, "padding", "20px 20px!important", "margin-left", "0"], [1, "mt-3", 2, "width", "105px", "height", "79px"], ["src", "../../../../content/images/blob-share.svg", "alt", "blob-share.svg"], [1, "mt-3"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.notReady"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.checkOut", 1, "check-out-text"], [1, "container", "resources-for-help-container", "bg-white", "d-flex", "align-items-center", "justify-content-start", "mt-3"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.supportResources", 3, "click"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.review.header", 1, "match-with-your-inuka-coach-header"], [1, "pt-4"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.experiencedCoaches"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.allCoaches"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.firstSession"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.sessionType"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.asMany"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.sessionDuration", 3, "translateValues", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.sessionSameDuration", 3, "translateValues", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.sessionDuration", 3, "translateValues"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howSession.sessionSameDuration", 3, "translateValues"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.session"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.1"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.2"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.3"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.4"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.summary.findYourself", 1, "match-with-your-inuka-coach-header", "mb-2"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.summary.explore", 1, "match-with-coach-text", "mb-2"], ["routerLink", "/session/schedule-session", "jhiTranslate", "inukaNgApp.wellbeingStart.viewAllCoaches", 1, "btn", "btn-link"], [1, "container", "more-question-container", "bg-white"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.howCoach.notReady", 1, "match-with-your-inuka-coach-header"], [1, "star"], [1, "half"], [1, "text-green"], [3, "icon"], [1, "text-green", "cursor"], [1, "modal-body", "container", "bg-white", "p-0", 2, "overflow-y", "hidden!important"], [1, "d-flex", "justify-content-end"], ["icon", "times-circle", 1, "close-icon", 3, "click"], [1, "modal-div"], [1, "review-count-div"], ["jhiTranslate", "inukaNgApp.wellBeingResult2.review.count", 1, "review-count", "btn", "btn-link", 3, "translateValues", "click"], ["class", "progress-bar-div", 4, "ngFor", "ngForOf"], [1, "feedback-message-div"], ["minBufferPx", "1200", "maxBufferPx", "1200", 3, "itemSize"], [4, "cdkVirtualFor", "cdkVirtualForOf", "cdkVirtualForTemplateCacheSize"], [1, "progress-bar-div"], [1, "d-flex", "justify-content-end", "align-items-center"], [2, "width", "73px!important", 3, "click"], [1, "star-count", "btn", "btn-link", 3, "jhiTranslate"], [1, "progress"], ["role", "progressbar", 1, "progress-bar", 2, "width", "1%", 3, "ngStyle"], [1, "percent-div"], [1, "d-flex", "justify-content-between", "align-items-center"], [1, "row", "align-items-center", 2, "margin-left", "0!important"], [2, "padding-bottom", "0!important", "margin-bottom", "0!important"], [2, "color", "#8A9D98", "margin", "0!important"], [1, "text-left", 2, "margin-top", "15px!important"], [1, "modal-body", "container", "bg-white", "p-0"], [3, "userId", "isPopup"]], template: function WellbeingResult2Component_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelement(4, "h3", 4);
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelement(7, "span", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵelement(9, "span", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 10);
        i0.ɵɵelement(11, "a", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 12);
        i0.ɵɵelementStart(13, "div");
        i0.ɵɵelement(14, "img", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 14);
        i0.ɵɵelementStart(16, "div", 12);
        i0.ɵɵelementStart(17, "div", 15);
        i0.ɵɵelement(18, "img", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 3);
        i0.ɵɵelementStart(20, "div", 17);
        i0.ɵɵelement(21, "p", 18);
        i0.ɵɵelement(22, "h3", 19);
        i0.ɵɵelement(23, "p", 20);
        i0.ɵɵelement(24, "button", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 22);
        i0.ɵɵelementStart(26, "div", 23);
        i0.ɵɵtemplate(27, WellbeingResult2Component_div_27_Template, 17, 7, "div", 24);
        i0.ɵɵelementStart(28, "div", 25);
        i0.ɵɵelementStart(29, "div", 26);
        i0.ɵɵlistener("click", function WellbeingResult2Component_Template_div_click_29_listener() { return ctx.showCoaches = !ctx.showCoaches; });
        i0.ɵɵelementStart(30, "div");
        i0.ɵɵelement(31, "a", 27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(33, "svg", 28);
        i0.ɵɵtemplate(34, WellbeingResult2Component__svg_use_34_Template, 1, 0, "use", 29);
        i0.ɵɵtemplate(35, WellbeingResult2Component__svg_use_35_Template, 1, 0, "use", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(36, WellbeingResult2Component_div_36_Template, 8, 0, "div", 31);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(37, "div", 32);
        i0.ɵɵelementStart(38, "div", 26);
        i0.ɵɵlistener("click", function WellbeingResult2Component_Template_div_click_38_listener() { return ctx.showHowSession = !ctx.showHowSession; });
        i0.ɵɵelementStart(39, "div");
        i0.ɵɵelement(40, "a", 33);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "div");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(42, "svg", 28);
        i0.ɵɵtemplate(43, WellbeingResult2Component__svg_use_43_Template, 1, 0, "use", 29);
        i0.ɵɵtemplate(44, WellbeingResult2Component__svg_use_44_Template, 1, 0, "use", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(45, WellbeingResult2Component_div_45_Template, 9, 1, "div", 31);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(46, "div", 25);
        i0.ɵɵelementStart(47, "div", 26);
        i0.ɵɵlistener("click", function WellbeingResult2Component_Template_div_click_47_listener() { return ctx.showHowCoach = !ctx.showHowCoach; });
        i0.ɵɵelementStart(48, "div");
        i0.ɵɵelement(49, "a", 34);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "div");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(51, "svg", 28);
        i0.ɵɵtemplate(52, WellbeingResult2Component__svg_use_52_Template, 1, 0, "use", 29);
        i0.ɵɵtemplate(53, WellbeingResult2Component__svg_use_53_Template, 1, 0, "use", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(54, WellbeingResult2Component_div_54_Template, 14, 1, "div", 31);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(55, "div", 35);
        i0.ɵɵtemplate(56, WellbeingResult2Component_div_56_Template, 4, 0, "div", 36);
        i0.ɵɵtemplate(57, WellbeingResult2Component_div_57_Template, 10, 0, "div", 37);
        i0.ɵɵelementStart(58, "div", 38);
        i0.ɵɵelement(59, "h3", 39);
        i0.ɵɵelementStart(60, "div", 40);
        i0.ɵɵelementStart(61, "a", 41);
        i0.ɵɵlistener("click", function WellbeingResult2Component_Template_a_click_61_listener() { return ctx.openFaqPage(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtext(62, "\u00A0 ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(63, "div", 42);
        i0.ɵɵelementStart(64, "a", 43);
        i0.ɵɵlistener("click", function WellbeingResult2Component_Template_a_click_64_listener() { return ctx.openMessageModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(65, "div", 44);
        i0.ɵɵelementStart(66, "div", 2);
        i0.ɵɵelementStart(67, "div", 45);
        i0.ɵɵelement(68, "img", 46);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(69, "div", 47);
        i0.ɵɵelement(70, "h3", 48);
        i0.ɵɵelementStart(71, "div");
        i0.ɵɵelementStart(72, "div", 49);
        i0.ɵɵelement(73, "span", 50);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(74, "div", 8);
        i0.ɵɵelement(75, "span", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(76, "div", 51);
        i0.ɵɵelement(77, "a", 52);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(78, "div", 53);
        i0.ɵɵelementStart(79, "div", 54);
        i0.ɵɵelementStart(80, "div", 15);
        i0.ɵɵelementStart(81, "div");
        i0.ɵɵelement(82, "img", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(83, "div", 17);
        i0.ɵɵelement(84, "p", 18);
        i0.ɵɵelement(85, "h3", 55);
        i0.ɵɵelement(86, "span", 20);
        i0.ɵɵelement(87, "br");
        i0.ɵɵelement(88, "button", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(89, WellbeingResult2Component_div_89_Template, 16, 6, "div", 24);
        i0.ɵɵelementStart(90, "div", 25);
        i0.ɵɵelementStart(91, "div", 26);
        i0.ɵɵlistener("click", function WellbeingResult2Component_Template_div_click_91_listener() { return ctx.showCoaches = !ctx.showCoaches; });
        i0.ɵɵelementStart(92, "div");
        i0.ɵɵelement(93, "a", 56);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(94, "div");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(95, "svg", 28);
        i0.ɵɵtemplate(96, WellbeingResult2Component__svg_use_96_Template, 1, 0, "use", 29);
        i0.ɵɵtemplate(97, WellbeingResult2Component__svg_use_97_Template, 1, 0, "use", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(98, WellbeingResult2Component_div_98_Template, 6, 0, "div", 31);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(99, "div", 32);
        i0.ɵɵelementStart(100, "div", 26);
        i0.ɵɵlistener("click", function WellbeingResult2Component_Template_div_click_100_listener() { return ctx.showHowSession = !ctx.showHowSession; });
        i0.ɵɵelementStart(101, "div");
        i0.ɵɵelement(102, "a", 57);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(103, "div");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(104, "svg", 28);
        i0.ɵɵtemplate(105, WellbeingResult2Component__svg_use_105_Template, 1, 0, "use", 29);
        i0.ɵɵtemplate(106, WellbeingResult2Component__svg_use_106_Template, 1, 0, "use", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(107, WellbeingResult2Component_div_107_Template, 9, 1, "div", 31);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(108, "div", 25);
        i0.ɵɵelementStart(109, "div", 26);
        i0.ɵɵlistener("click", function WellbeingResult2Component_Template_div_click_109_listener() { return ctx.showHowCoach = !ctx.showHowCoach; });
        i0.ɵɵelement(110, "a", 58);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(111, "svg", 28);
        i0.ɵɵtemplate(112, WellbeingResult2Component__svg_use_112_Template, 1, 0, "use", 29);
        i0.ɵɵtemplate(113, WellbeingResult2Component__svg_use_113_Template, 1, 0, "use", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(114, WellbeingResult2Component_div_114_Template, 14, 1, "div", 31);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(115, WellbeingResult2Component_div_115_Template, 5, 0, "div", 36);
        i0.ɵɵtemplate(116, WellbeingResult2Component_div_116_Template, 10, 0, "div", 59);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(117, "div", 60);
        i0.ɵɵelement(118, "h3", 61);
        i0.ɵɵelementStart(119, "div", 40);
        i0.ɵɵelementStart(120, "a", 41);
        i0.ɵɵlistener("click", function WellbeingResult2Component_Template_a_click_120_listener() { return ctx.openFaqPage(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtext(121, "\u00A0 ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(122, "div", 42);
        i0.ɵɵelementStart(123, "a", 43);
        i0.ɵɵlistener("click", function WellbeingResult2Component_Template_a_click_123_listener() { return ctx.openMessageModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(124, WellbeingResult2Component_ng_template_124_Template, 6, 8, "ng-template", null, 62, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(126, WellbeingResult2Component_ng_template_126_Template, 12, 10, "ng-template", null, 63, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(128, WellbeingResult2Component_ng_template_128_Template, 6, 2, "ng-template", null, 64, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(36, _c5, ctx.currentUser == null ? null : ctx.currentUser.login));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("jhiTranslate", ctx.getSummaryText(0));
        i0.ɵɵadvance(15);
        i0.ɵɵproperty("routerLink", ctx.startNowLink);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.approvedList == null ? null : ctx.approvedList.length);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(38, _c6, ctx.showCoaches ? "15px" : "0"));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.showCoaches);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showCoaches);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showCoaches);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(40, _c6, ctx.showHowSession ? "15px" : "0"));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.showHowSession);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showHowSession);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showHowSession);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(42, _c6, ctx.showHowCoach ? "15px" : "0"));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.showHowCoach);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showHowCoach);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showHowCoach);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selectedTip != null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showResourcesLink);
        i0.ɵɵadvance(13);
        i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(44, _c5, ctx.currentUser == null ? null : ctx.currentUser.login));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("jhiTranslate", ctx.getSummaryText(0));
        i0.ɵɵadvance(13);
        i0.ɵɵproperty("routerLink", ctx.startNowLink);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.approvedList == null ? null : ctx.approvedList.length);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.showCoaches);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showCoaches);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showCoaches);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.showHowSession);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showHowSession);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showHowSession);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.showHowCoach);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showHowCoach);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showHowCoach);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTip != null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showResourcesLink);
    } }, directives: [i14.JhiTranslateDirective, i4.RouterLinkWithHref, i4.RouterLink, i15.NgIf, i16.FaIconComponent, i5.NgbRating, i15.NgForOf, i17.CdkVirtualScrollViewport, i17.CdkFixedSizeVirtualScroll, i17.CdkVirtualForOf, i15.NgStyle, i18.OrganizationResourcesComponent], pipes: [i19.FormatDateStringPipe, i15.DatePipe], styles: [".container[_ngcontent-%COMP%]{border-radius:20px !important}.summary-container[_ngcontent-%COMP%]{width:auto !important;padding:20px !important;margin:90px 20px 20px 20px}.thank-you-header[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);font-family:Poppins,serif;font-style:normal;font-weight:700;line-height:130%}.text-18[_ngcontent-%COMP%]{color:var(--Dark-Text, #0A4A3A);font-family:Open Sans,serif;font-size:18px;font-style:normal;font-weight:400;line-height:150%}.text-14[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);font-family:Open Sans,serif;font-size:14px;font-style:normal;font-weight:400;line-height:130%}.text-16[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);font-family:Open Sans,serif;font-size:16px;font-style:normal;font-weight:400;line-height:140%}.text-12[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);font-feature-settings:\"clig\" off,\"liga\" off;font-family:Open Sans,serif;font-size:12px;font-style:normal;font-weight:400;line-height:140%}.match-with-coach-container[_ngcontent-%COMP%]{padding:20px 15px 15px 15px !important;margin:20px auto 20px auto;border-radius:10px;background:#f7eed2}.match-with-your-inuka-coach-header[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);font-family:Poppins,serif;font-size:18px;font-style:normal;font-weight:600;line-height:130%}.match-with-coach-text[_ngcontent-%COMP%]{color:var(--Text-Green-Light-Text, #9DB7B0);font-family:Open Sans,serif;font-style:normal;font-weight:400;line-height:140%}.scroll[_ngcontent-%COMP%]{display:flex;width:40px;height:40px;padding:10px;margin:8px;justify-content:center;align-items:center;gap:10px;flex-shrink:0;border-radius:1000px;background-color:#fafaff;border:1px solid var(--Text-Green-Light-Text, #9DB7B0)}.scroll[_ngcontent-%COMP%]:hover{border:1px solid var(--Fill-Green, #44A38B)}.review-scroll-arrow[_ngcontent-%COMP%]{color:var(--Text-Green-Light-Text, #9DB7B0);font-size:16px}.review-scroll-arrow[_ngcontent-%COMP%]:hover{color:var(--Fill-Green, #44A38B)}.rating-container[_ngcontent-%COMP%]{display:flex;width:340px;height:174px;overflow:scroll;padding:16px;flex-direction:column;align-items:flex-start;gap:16px;border-radius:8px;background:var(--Fill-Background-2---Extra-light, #F8F7F2);flex:1}.angle-icon[_ngcontent-%COMP%]{height:24px;width:24px;cursor:pointer}.tip-title[_ngcontent-%COMP%]{color:var(--Fill-Green, #44A38B);font-family:Poppins,serif;font-size:14px;font-style:normal;font-weight:600;line-height:130%}.headlines-ul[_ngcontent-%COMP%]{padding-inline-start:0 !important}.headlines[_ngcontent-%COMP%]{list-style-type:none;margin-bottom:10px}.headlines-span[_ngcontent-%COMP%]{margin-left:10px}.check-out-text[_ngcontent-%COMP%]{align-self:stretch;color:var(--Text-Green-Light-Text, #9DB7B0);font-feature-settings:\"clig\" off,\"liga\" off;font-family:Open Sans,serif;font-style:normal;font-weight:400;line-height:140%}.writer[_ngcontent-%COMP%]{color:var(--Text-Green-Light-Text, #9DB7B0);font-family:Poppins,serif;font-size:14px;font-style:normal;font-weight:600;line-height:130%}.bottom-div[_ngcontent-%COMP%]{margin:20px !important;padding:0 !important;height:100% !important;width:auto !important}.how-session-container[_ngcontent-%COMP%], .how-coach-container[_ngcontent-%COMP%], .review-container[_ngcontent-%COMP%], .meet-coaches-container-inside[_ngcontent-%COMP%], .more-question-container[_ngcontent-%COMP%]{padding:20px !important;width:auto !important;margin:20px !important}.meet-coaches-container[_ngcontent-%COMP%]{padding:20px !important;margin:20px !important;width:auto !important}.review-container[_ngcontent-%COMP%]{cursor:pointer !important}.resources-for-help-container[_ngcontent-%COMP%]{padding:0 !important;margin:0 !important;width:auto !important}.resources-for-help-container[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:underline;cursor:pointer;align-self:stretch;color:var(--Fill-Green, #44A38B);font-family:Poppins,serif;font-size:14px;font-style:normal;font-weight:700;line-height:100%}ul[_ngcontent-%COMP%], ol[_ngcontent-%COMP%]{padding-inline-start:20px !important}.image-div[_ngcontent-%COMP%]{width:214px !important;height:189px !important;display:flex;align-items:flex-start;justify-content:center}.image[_ngcontent-%COMP%]{height:141px !important;width:141px !important;min-height:75px !important;min-width:83px !important}.total-score-bubble[_ngcontent-%COMP%]{font-size:16px !important;height:30px !important;width:30px !important;border-radius:4px !important;font-weight:900 !important;float:left !important;margin-right:10px !important}span[_ngcontent-%COMP%]{margin-right:3px;margin-bottom:3px}body[_ngcontent-%COMP%]   .button-div[_ngcontent-%COMP%]{margin-left:auto !important;margin-right:auto !important;text-align:center !important}body[_ngcontent-%COMP%]   .meet-coaches-button-div[_ngcontent-%COMP%]{margin-top:20px !important;margin-left:auto !important;margin-right:auto !important;text-align:center !important}button[_ngcontent-%COMP%]{width:140px;height:40px;font-size:10px}.star[_ngcontent-%COMP%]{position:relative;display:inline-block;font-size:1rem}.half[_ngcontent-%COMP%]{position:absolute;display:inline-block;overflow:hidden}.text-green[_ngcontent-%COMP%]{color:#44a38b !important;font-weight:bold !important}.review-count-div[_ngcontent-%COMP%]{margin-top:10px !important}.review-count[_ngcontent-%COMP%]{color:#44a38b !important;font-weight:bold !important;margin:0 0 0 10px !important}.star-count[_ngcontent-%COMP%]{color:#44a38b !important;text-align:left !important;font-weight:bold !important;width:12% !important}.percent-div[_ngcontent-%COMP%]{width:9% !important;text-align:right !important}.close-icon[_ngcontent-%COMP%]{background:#fff;color:rgba(10,74,58,.2);margin:10px;cursor:pointer}.modal-div[_ngcontent-%COMP%]{text-align:left !important;padding-left:30px !important;padding-right:30px !important;margin-bottom:50px !important}.progress-bar-div[_ngcontent-%COMP%]{margin-top:15px !important}.feedback-message-div[_ngcontent-%COMP%]{margin-top:15px !important;height:350px !important;overflow-y:scroll !important}.progress[_ngcontent-%COMP%]{background:#cce9e0;width:78% !important;border-radius:3px;height:6px;margin:auto !important}.progress-bar[_ngcontent-%COMP%]{background-color:var(--main)}.inuka-bird-div[_ngcontent-%COMP%]{background:#fff !important;margin:0 auto !important;border-radius:50% !important;width:54px !important;height:54px !important}.inuka-bird[_ngcontent-%COMP%]{padding:12px !important}.arrow[_ngcontent-%COMP%]{padding:16px 21px !important}.left-arrow[_ngcontent-%COMP%]{position:absolute;left:-37px;top:calc(50% - 27px);background:#fff !important;margin:0 auto !important;border-radius:50% !important;width:54px !important;height:54px !important;cursor:pointer}.right-arrow[_ngcontent-%COMP%]{position:absolute;right:-37px;top:calc(50% - 27px);background:#fff !important;margin:0 auto !important;border-radius:50% !important;width:54px !important;height:54px !important;cursor:pointer}cdk-virtual-scroll-viewport[_ngcontent-%COMP%]{height:350px !important}.meet-coaches-login[_ngcontent-%COMP%], .meet-coaches-message[_ngcontent-%COMP%]{margin-top:10px !important;color:#0a4a3a}.vl[_ngcontent-%COMP%]{border-left:1px solid #cedbd7;height:220px}.hl[_ngcontent-%COMP%]{border-top:1px solid #cedbd7;width:90%}@media(min-width: 576px){.image[_ngcontent-%COMP%]{height:141px;width:141px}.resources-for-help-container[_ngcontent-%COMP%]{width:100% !important;margin:auto auto 0 auto !important}.summary-container[_ngcontent-%COMP%]{padding:20px !important;margin:100px auto 20px auto !important}.how-session-container[_ngcontent-%COMP%], .how-coach-container[_ngcontent-%COMP%], .review-container[_ngcontent-%COMP%], .meet-coaches-container-inside[_ngcontent-%COMP%], .more-question-container[_ngcontent-%COMP%]{margin:0 auto 20px auto !important}.meet-coaches-container[_ngcontent-%COMP%]{margin:20px auto 20px auto !important}.bottom-div[_ngcontent-%COMP%]{max-width:540px !important}button[_ngcontent-%COMP%]{width:220px;height:50px;font-size:14px}}@media(min-width: 768px){.bottom-div[_ngcontent-%COMP%]{margin:20px auto 30px auto !important;max-width:720px !important}.total-score-bubble[_ngcontent-%COMP%]{font-size:26px !important;height:50px !important;width:50px !important;border-radius:5px !important}.button-div[_ngcontent-%COMP%]{text-align:left !important}}@media(min-width: 992px){.match-with-coach-container[_ngcontent-%COMP%]{padding:30px 30px 20px 30px !important}.thank-you-header[_ngcontent-%COMP%]{padding-top:10px !important;color:var(--Dark-Text, #0A4A3A);font-family:Poppins,serif;font-size:26px;font-style:normal;font-weight:700;line-height:140%}.match-with-your-inuka-coach-header[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);font-family:Poppins,serif;font-size:20px;font-style:normal;font-weight:700;line-height:130%}.match-with-coach-text[_ngcontent-%COMP%]{color:var(--Text-Green-Light-Text, #9DB7B0) !important;font-family:Open Sans,serif;font-size:16px;font-style:normal;font-weight:400;line-height:130%}.tip-title[_ngcontent-%COMP%]{color:var(--Fill-Green, #44A38B) !important;text-align:center;font-family:Poppins,serif;font-size:16px;font-style:normal;font-weight:600;line-height:130%}.how-session-container[_ngcontent-%COMP%], .how-coach-container[_ngcontent-%COMP%], .review-container[_ngcontent-%COMP%], .meet-coaches-container-inside[_ngcontent-%COMP%], .more-question-container[_ngcontent-%COMP%]{padding:20px 20px 13px 20px !important;margin:0 auto 20px auto !important}.meet-coaches-container[_ngcontent-%COMP%]{padding:20px !important;margin:0 auto 20px auto !important}.bottom-div[_ngcontent-%COMP%]{max-width:960px !important}cdk-virtual-scroll-viewport[_ngcontent-%COMP%]{height:500px !important}.feedback-message-div[_ngcontent-%COMP%]{height:500px !important}}@media(min-width: 1200px){.bottom-div[_ngcontent-%COMP%]{max-width:1140px !important}}"] });
